import isTouchDevice from "./helpers/isTouchDevice";
const parallaxOff = () =>{
    if(isTouchDevice){
        const allParallaxCovers = document.querySelectorAll('.has-parallax');
        if(allParallaxCovers.length > 0){
            allParallaxCovers.forEach(cover =>{
                cover.classList.add('parallax-off');
            });
        }

    }
}
export default parallaxOff;